const firebaseConfig = {
    apiKey: "AIzaSyCYo7nEOiB6-koXT2wpFuEHyrSqVp7WlJg",
    authDomain: "ph-ema-jhon.firebaseapp.com",
    projectId: "ph-ema-jhon",
    storageBucket: "ph-ema-jhon.appspot.com",
    messagingSenderId: "23629187390",
    appId: "1:23629187390:web:346e1db4ba30779e40046f",
    measurementId: "G-N8CJBZGC8K"
};

export default firebaseConfig;